// The page API's reply → the text and its suggested-question buttons
// (docs/suggested-questions-design.md §10.1). At most 4, text only. Its own
// file so node --test can load it (brandPageApi.js reads Vite's env).
export function replyOf(json) {
  const data = json?.data ?? {};
  const suggestions = Array.isArray(data.suggestions)
    ? data.suggestions.filter((q) => typeof q === 'string' && q.trim()).slice(0, 4)
    : [];
  return { content: typeof data.content === 'string' ? data.content : '', suggestions };
}
